<template>
  <span
    v-if="discount > 0 && !hidePrices"
    class="sale-flash"
    :class="{ 'sale-flash--big': saleType == 'article', 'sale-flash--big product-teaser--big__sale-flash': saleType == 'big-teaser' }"
  >
    -{{ discount }}%
  </span>
</template>

<script>
import { EventBus } from '../../event-bus.js';

export default {
    props: {
        product: {
            type: Object,
            default: function () {
                return {};
            },
        },
        teaserMode: Boolean,
        saleType: {
            type: String,
            default: '',
        },
        hidePrices: Boolean,
    },

    data : function () {
        return {
            price_with_tax: this.product.prices_with_tax.price_from_with_add_ons,
            regular_price_with_tax: this.product.prices_with_tax.regular_price_from_with_add_ons,
            discount: 0,
        }
    },
    created: function () {

        this.countDiscount();

        if(!this.teaserMode) {

            EventBus.$on('total-price-changed', total_price => {
                this.countDiscountByTotalPrice(total_price);
            });

        }

    },

    methods: {
        calculateDiscountPercentage( discountedPrice, normalPrice ) {
            return 100 - 100 * (discountedPrice / normalPrice);
        },

        roundValue: function ( percentage ) {
            // round down to nearest 5
            return Math.floor( percentage / 5 ) * 5;
        },

        countDiscountByTotalPrice : function(total_price) {
            const discountPercentage = this.calculateDiscountPercentage( total_price.price_with_tax, total_price.regular_price_with_tax );
            this.discount = this.roundValue( discountPercentage );
        },

        countDiscount: function () {
            const total_price = {
                price_with_tax: this.price_with_tax,
                regular_price_with_tax: this.regular_price_with_tax,
            };

            if ( typeof this.product.variations !== 'undefined' && this.product.variations.length > 0 ) {
                //count discount for variations
                const cheapestVariation = this.getCheapestVariation( this.product );
                total_price.price_with_tax = cheapestVariation.prices_with_tax.price;
                total_price.regular_price_with_tax = cheapestVariation.prices_with_tax.regular_price;
            }

            this.countDiscountByTotalPrice( total_price );
        },

        getCheapestVariation(product) {
            let chepeastVariation = product.variations[0];

            product.variations.forEach(function(variation) {
                if(variation.prices_with_tax.price < chepeastVariation.prices_with_tax.price) {
                    chepeastVariation = variation;
                }
            });

            return chepeastVariation;
        },
    },
}
</script>
